import React, { useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../utils/config';
/**
 * Component for generating sitemap.xml
 * This is meant to be used with a route like /sitemap.xml
 */
const Sitemap = () => {
  useEffect(() => {
    // This component doesn't render anything visible
    // It just fetches the sitemap from the backend and sets it as the response
    const fetchSitemap = async () => {
      try {
        const response = await axios.get(`${API_URL}/seo/sitemap.xml`, {
          responseType: 'text'
        });
        // Set the content type to XML
        document.contentType = 'application/xml';
        // Replace the document content with the sitemap XML
        document.documentElement.innerHTML = response.data;
        // Set the content type in the response headers
        // Add Content-Type meta tag
        let meta = document.querySelector('meta[http-equiv="Content-Type"]');
        if (!meta) {
          meta = document.createElement('meta');
          meta.setAttribute('http-equiv', 'Content-Type');
          meta.setAttribute('content', 'application/xml');
          document.head.appendChild(meta);
        }
        // Add canonical URL
        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
          canonical = document.createElement('link');
          canonical.setAttribute('rel', 'canonical');
          document.head.appendChild(canonical);
        }
        canonical.setAttribute('href', `${window.location.origin}/sitemap.xml`);
      } catch (error) {}
    };
    fetchSitemap();
  }, []);
  // This component doesn't render anything visible
  return null;
};
export default Sitemap;